import { render, staticRenderFns } from "./Menuz.vue?vue&type=template&id=599f2802&scoped=true"
import script from "./Menuz.vue?vue&type=script&lang=js"
export * from "./Menuz.vue?vue&type=script&lang=js"
import style0 from "./Menuz.vue?vue&type=style&index=0&id=599f2802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f2802",
  null
  
)

export default component.exports